export function BrandName({ name, mobileName }: { name: string; mobileName?: string }) {
  return <span className="site-brand-name">{mobileName ? <><span className="brand-name-desktop">{name}</span><span className="brand-name-mobile">{mobileName}</span></> : name}</span>;
}
